<script lang="ts">
	import { ProjectorIcon, AccountIcon, ImgIcon, LuxCastIcon, VidIcon, GridIcon } from "luxedo-icons"
	import { Link } from "svelte-routing"
	import Header from "../../reusable/Header.svelte"
	import { onMount } from "svelte"
</script>

<Header heading="Luxedo Admin" hideBackBtn />
<main id="Dashboard">
	<div class="opts-container">
		<Link to="/admin/device">
			<button class="card-button only-icon">
				<ProjectorIcon />
				Active Devices
			</button>
		</Link>
		<Link to="/admin/user">
			<button class="card-button only-icon">
				<AccountIcon />
				Active Accounts
			</button></Link
		>
		<Link to="/admin/testing">
			<button class="card-button only-icon">
				<LuxCastIcon />
				Test Station
			</button>
		</Link>
		<Link to="/admin/media">
			<button class="card-button only-icon">
				<VidIcon />
				Media Manager
			</button>
		</Link>
		<Link to="/admin/snapshots">
			<button class="card-button only-icon">
				<ImgIcon />
				Snapshot Downloader
			</button>
		</Link>
		<Link to="/admin/mass-update">
			<button class="card-button only-icon">
				<GridIcon />
				Mass Updater
			</button>
		</Link>
	</div>
</main>

<style>
	main {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	main :global(a) {
		border-bottom: unset;
	}

	.card-button {
		transition:
			color 500ms,
			background-color 500ms,
			transform 500ms;
	}

	.card-button :global(.svg-stroke) {
		transition: stroke 500ms;
	}

	.opts-container {
		display: grid;
		box-sizing: border-box;
		padding: 2rem;
		width: 100vw;
		height: calc(100vh - var(--header-height));
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr;
		align-items: center;
		justify-items: center;
	}

	.opts-container button {
		width: 15vw;
		height: 15vw;
	}

	.opts-container button :global(svg) {
		margin-bottom: 1rem;
	}
</style>
